import { useEffect, useRef, useState } from 'react';
import { Observable } from '../../Data/Observable/Observable';
const direction = new Observable('ltr');
export function useDirection() {
    const [state, setState] = useState(direction.value);
    const state_ref = useRef(direction.value);
    useEffect(() => {
        const sub = direction.subscribe(dir => {
            if (state_ref.current === dir) {
                return;
            }
            setState(dir);
            state_ref.current = dir;
        });
        return () => sub.unsubscribe();
    }, []);
    return [state];
}
export function setDirection(dir) {
    if (dir !== 'rtl' && dir !== 'ltr') {
        dir = 'ltr';
    }
    if (dir === direction.value) {
        return direction;
    }
    return direction.next(dir);
}
export function getDirection() {
    return direction;
}
